import React from "react"
import { useLocation } from "react-router-dom"
import Layout from "components/Layout/Layout"
import CommonTitle from "components/common/CommonTitle"
import GoBackButton from "components/Button/GoBackButton"
import Estimable from "pages/Estimable"
import { Box } from "@mui/material"
import styles from "./Error.module.scss"
/**
 * エラー画面
 * @param {any} props - {api: API名, message: 表示するエラー内容, isNotCovered: TrueならStep1対象外の車種を表示}
 */
const Error = (props: any) => {
  const location = useLocation()
  const errorState = location.state
  const api = errorState ? errorState.api : ""
  const message = errorState ? errorState.message : ""
  const isNotCovered = errorState ? errorState.isNotCovered : false

  const titles = ["申し訳ございません。"]
  if (api) {
    titles.push(`${api}に失敗しました。`)
  } else {
    titles.push("トップ画面から、")
    titles.push("お見積りください。")
  }

  return (
    <>
      {isNotCovered ? (
        <Estimable isNotCovered={isNotCovered} />
      ) : (
        <Layout>
          <Box className={styles.nonStepBarWrap}>
            <CommonTitle titles={titles} read={message} />
            <GoBackButton top text="トップ画面に戻る" />
          </Box>
        </Layout>
      )}
    </>
  )
}

export default Error
